import AssistantResponseCard from './assistant-responses';
import AssistantCommandLoading from './assistant-command-loading';
import { CommandResult } from '../../models/chatbot/command-result';
import './assistant.scss';

type ChatbotCommandResultProps = {
  result: CommandResult | null;
  isLoading: boolean;
};

/**
 * Displays only the result of the last command execution.
 * Unlike AssistantHistoryItem, this does NOT show:
 * - The user's command text (replaced with metadata.button_text as header)
 * - A chat-like conversation history
 * - Multiple messages
 *
 * It only shows the response data in a clean, simplified format with a header.
 */
const ChatbotCommandResult = ({
  result,
  isLoading,
}: ChatbotCommandResultProps) => {
  if (isLoading) {
    return (
      <div className="chatbot-command-result">
        <AssistantCommandLoading />
      </div>
    );
  }

  if (!result) {
    return null;
  }

  return (
    <div className="chatbot-command-result">
      {result.headerText && (
        <h2 className="chatbot-command-result__header">{result.headerText}</h2>
      )}
      {result.subject && (
        <AssistantResponseCard
          response={result.subject}
          analyticsData={{}}
          historyItemId="chatbot-result"
        />
      )}
      {result.error && result.text && (
        <div className="chatbot-command-result__text chatbot-command-result__text--error">
          {result.text}
        </div>
      )}
    </div>
  );
};

export default ChatbotCommandResult;
